module.exports = __webpack_public_path__ + "img/logoAutoAtendimento.3447dbea.jpg";